import type { Listing } from '@thevillages/schemas';

import { CurrencyPipe } from '@angular/common';
import { DecimalPipe } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';

// import { NgOptimizedImage } from '@angular/common';
import { ComputedListingBaths, ComputedListingOpenNow } from '../../../../computed-values';
import { StateService } from '../../../../services/state/state';
import { HomeListingCardOpenHouse } from '../../../listing-card/home/open-house/open-house';

@Component({
  imports: [CurrencyPipe, DecimalPipe, HomeListingCardOpenHouse],
  selector: 'app-map-listing-popover-home',
  styleUrl: './home.css',
  templateUrl: './home.html',
})
export class MapListingPopoverHome {
  protected readonly stateService = inject(StateService);

  public readonly listing = input.required<Listing>();

  protected readonly baths = computed(() => ComputedListingBaths(this.listing()));
  protected readonly openNow = computed(() => ComputedListingOpenNow(this.listing()));
}
